module.exports = ".prop-name {\n  font-weight: 300;\n  color: #3a3a3a; }\n\n.details-row {\n  line-height: 1.2;\n  padding-bottom: 10px; }\n"